import axios from "axios";

type setMakeUpProps = {
    loginId: string;
    attachmentsId: number;
    selectedDate: string;
    joinedDate: string;
    clubName: string;
    memo: string;
    rotaryCd:  string;
}

/**
 * メークアップ情報を登録するAPI
 */

export async function setMakeUp(props: setMakeUpProps){
    try{
        //  API呼出し
        const response = await axios.post(process.env.REACT_APP_PATH + `/makeup/set-makeup`, null, {
            params:{
                loginId:     props.loginId,
                attachmentsId:  props.attachmentsId,
                selectedDate:   props.selectedDate,
                joinedDate:     props.joinedDate,
                clubName:       props.clubName,
                memo:           props.memo,
                rotaryCd:       props.rotaryCd
            }
        })

        //  登録したメークアップIDを返す
        return JSON.parse(JSON.stringify(response.data))[0].id

    }catch(error){
        console.warn(error)
    }
}